/**
 * Enum danh sách các năm
 * VDDONG 27/04/2023
 */
export default {
  Y2020: 2020,
  Y2021: 2021,
  Y2022: 2022,
  Y2023: 2023,
  Y2024: 2024,
};
